import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DashboardMain from './DashboardMain';
import Breadcrumb from '../../components/Breadcrumb';
import Footer from '../../components/Footer';

import Logo from '../../assets/images/logos/logo2.png';
import Swal from 'sweetalert2';

const StudentDashboard = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out of your account.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#1e40af',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, logout'
        }).then((result) => {
            if (result.isConfirmed) {
            localStorage.removeItem('guest_user_role');
            localStorage.removeItem('guest_access_token');
            localStorage.removeItem('guest_refresh_token');
            localStorage.removeItem('guest_college_code');
            localStorage.removeItem('guest_college_name');
            localStorage.removeItem('guest_student_id');
            sessionStorage.removeItem('guest_user_role');
            sessionStorage.removeItem('guest_college_code');
            sessionStorage.removeItem('guest_college_name');
            sessionStorage.removeItem('guest_student_id');
            Swal.fire({
                title: 'Logged Out',
                text: 'You have successfully logged out.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false,
                confirmButtonColor: '#1e40af'
            }).then(() => {
                navigate('/login');
            });
            }
        });
    };

    return (
        <div className="student-dashboard-page">
            <header className="header-area">
                <div className="menu-part" style={{ borderBottom: '1px solid #E8ECF4', background: '#fff' }}>
                    <div className="container">
                        <div style={{ padding: '14px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Link to="/dashboard/student" className="logo-text">
                                <img src={Logo} alt="Student Logo" style={{ height: '55px' }} />
                            </Link>
                            <button
                                type="button"
                                onClick={handleLogout}
                                className="react-btn-primary"
                                style={{
                                    background: '#1e40af',
                                    border: '2px solid #1e3a8a',
                                    padding: '8px 20px',
                                    borderRadius: '8px',
                                    color: '#fff',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.3)',
                                    textDecoration: 'none',
                                    display: 'inline-block',
                                    textTransform: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            <Breadcrumb pageTitle="Student Dashboard" />
            <DashboardMain role="student" />
            <Footer footerClass="react-footer home-main student-mobile-fixed-footer" />
        </div>
    );
};

export default StudentDashboard;
